export const GENERATION_CAPACITY_EXHAUSTED_MESSAGE =
  'Generation capacity is used for the current period.';

export class GenerationCapacityExhaustedError extends Error {
  constructor() {
    super(GENERATION_CAPACITY_EXHAUSTED_MESSAGE);
    this.name = 'GenerationCapacityExhaustedError';
  }
}

export function isGenerationCapacityExhaustedError(error: unknown): boolean {
  return (
    error instanceof GenerationCapacityExhaustedError ||
    (error instanceof Error && error.message === GENERATION_CAPACITY_EXHAUSTED_MESSAGE)
  );
}

export function isGenerationCapacityExhaustedMessage(message: string | null | undefined): boolean {
  return message === GENERATION_CAPACITY_EXHAUSTED_MESSAGE;
}
